const PARTICIPANT_STORAGE_KEYS = {
    perfil: 'participantPerfil',
    idUsuario: 'participantIdUsuario',
    nomeUsuario: 'participantNomeUsuario',
    token: 'participantToken',
};

const PARTICIPANT_ROUTE_PREFIXES = [
    '/loginEvento',
    '/loginConfirmarDados',
    '/loginRapido',
    '/cadastroEventoParticipanteAceitarTermo',
    '/cadastroEventoParticipanteAceitarConvite',
    '/cadastroEventoParticipanteCartaInformativa',
    '/cadastroEventoParticipanteConvite',
    '/cadastroEventoParticipanteAereoConvite',
    '/cadastroEventoParticipanteTransferConvite',
    '/cadastroEventoParticipanteHotelConvite',
    '/cadastroEventoParticipanteLista',
    '/cadastroEventoParticipanteListaConcluido',
    '/cadastroEventoParticipanteConviteConcluido',
    '/cadastroEventoParticipanteContratoEnviado',
    '/cadastroEventoParticipanteConviteRecusado',
    '/cadastroEventoParticipanteAssinatura',
];

function getStorage(storageName) {
    if (typeof window === 'undefined') {
        return null;
    }

    return window[storageName] ?? null;
}

function getCurrentPathname() {
    if (typeof window === 'undefined') {
        return '';
    }

    return window.location.pathname || '';
}

function readAuth(storage, keys) {
    if (!storage) {
        return {
            perfil: null,
            idUsuario: null,
            nomeUsuario: null,
            token: null,
        };
    }

    return {
        perfil: storage.getItem(keys.perfil),
        idUsuario: storage.getItem(keys.idUsuario),
        nomeUsuario: storage.getItem(keys.nomeUsuario),
        token: storage.getItem(keys.token),
    };
}

export function isParticipantPublicRoute(pathname = getCurrentPathname()) {
    return PARTICIPANT_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export function saveParticipantAuth({ id, nome, api_token, perfil = 'cliente' }) {
    const storage = getStorage('sessionStorage');

    if (!storage) {
        return;
    }

    storage.setItem(PARTICIPANT_STORAGE_KEYS.perfil, perfil);
    storage.setItem(PARTICIPANT_STORAGE_KEYS.idUsuario, id);
    storage.setItem(PARTICIPANT_STORAGE_KEYS.nomeUsuario, nome);
    storage.setItem(PARTICIPANT_STORAGE_KEYS.token, api_token);
}

export function clearParticipantAuth() {
    const storage = getStorage('sessionStorage');

    if (!storage) {
        return;
    }

    Object.values(PARTICIPANT_STORAGE_KEYS).forEach((key) => storage.removeItem(key));
}

export function getParticipantAuth() {
    return readAuth(getStorage('sessionStorage'), PARTICIPANT_STORAGE_KEYS);
}

export function getInternalAuth() {
    return readAuth(getStorage('localStorage'), {
        perfil: 'perfil',
        idUsuario: 'idUsuario',
        nomeUsuario: 'nomeUsuario',
        token: 'token',
    });
}

export function getAuthForPath(pathname = getCurrentPathname()) {
    if (isParticipantPublicRoute(pathname)) {
        const participantAuth = getParticipantAuth();

        if (participantAuth.token) {
            return participantAuth;
        }
    }

    return getInternalAuth();
}

// Sessão de participante (convidado): rota pública de participante COM token de participante.
// Um usuário interno (pessoa) navegando numa rota dessas cai no auth interno, então retorna false.
export function isParticipantSession(pathname = getCurrentPathname()) {
    return isParticipantPublicRoute(pathname) && !!getParticipantAuth().token;
}

export function getAuthToken(pathname = getCurrentPathname()) {
    return getAuthForPath(pathname).token;
}

export function getAuthPerfil(pathname = getCurrentPathname()) {
    return getAuthForPath(pathname).perfil;
}
